import { z } from 'zod';
import PackageVendorPicksPage from '@pages/PackageVendorPicks';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/connect/_authenticated/packageVendorPicks')({
  component: PackageVendorPicksPage,
  validateSearch: z.object({
    trackingId: z.string(),
  }),
});
